import { HttpClient } from "@angular/common/http";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { InventarioContextService } from "app/shared/service/inventario-context.service";
import { environment } from "environments/environment";
import { InventarioService } from "../../inventario.service";
import { RelatorioEmailDialogComponent } from "../relatorio-dialog/relatorio-dialog.component";

@Component({
  selector: "app-drawer-menu",
  templateUrl: "./drawer-menu.component.html",
  styleUrls: ["./drawer-menu.component.scss"],
})
export class DrawerMenuComponent implements OnInit {
  @Input() idInventario?: string;
  @Input() latitude?: number;
  @Input() longitude?: number;
  @Output() closeMenu = new EventEmitter<void>();

  isNovo: boolean = false;
  statusFormularios: { [key: string]: boolean } = {};
  private statusCarregado: boolean = false;
  isLoading: boolean = false;

  constructor(
    private router: Router,
    private inventarioService: InventarioService,
    private inventarioContext: InventarioContextService,
    private http: HttpClient,
    private dialog: MatDialog,
  ) { }

  routes = [
    {
      key: "INVENTARIO_COMBUSTAO",
      label: "Combustível",
      getRoute: () => `/combustivel/form/${this.idInventario}`,
      icon: "local_gas_station",
    },
    {
      key: "INVENTARIO_FERTILIZANTE",
      label: "Fertilizantes",
      getRoute: () => `/fertilizante/form/${this.idInventario}`,
      icon: "science",
    },
    {
      key: "INVENTARIO_RESIDUO_AGRICOLA",
      label: "Resíduos Agrícolas",
      getRoute: () => `/residuos-agricolas/form/${this.idInventario}`,
      icon: "compost",
    },
    {
      key: "RESIDUO_SOLIDO_EFLUENTE",
      label: "Resíduos Sólidos e Efluentes",
      getRoute: () => `/residuo-solido-efluente/form/${this.idInventario}`,
      icon: "recycling",
    },
    {
      key: "EMISSOES_FUGITIVAS",
      label: "Emissões Fugitivas",
      getRoute: () => `/emissoes-fugitivas/form/${this.idInventario}`,
      icon: "air",
    },
    {
      key: "ENERGIA_ELETRICA",
      label: "Energia Elétrica",
      getRoute: () => `/energia-eletrica/form/${this.idInventario}`,
      icon: "bolt",
    },
    {
      key: "MANEJO_SOLOS_ORGANICOS",
      label: "Manejo de Solos Orgânicos",
      getRoute: () => `/manejo-solos-organicos/form/${this.idInventario}`,
      icon: "agriculture",
    },
    {
      key: "MANEJO_DEJETOS_FERMENTACAO_ENTERICA",
      label: "Criação Pecuária",
      getRoute: () => `/criacao-pecuaria/form/${this.idInventario}`,
      icon: "pets",
    },
    {
      key: "INVENTARIO_SUMIDOURO",
      label: "Inventário de Sumidouros",
      getRoute: () => `/inventario-sumidouros/form/${this.idInventario}`,
      icon: "forest",
    },
    {
      key: "ATIVIDADES_TERCEIRIZADAS_TRANSPORTE",
      label: "Atividades Terceirizadas",
      getRoute: () => `/atividades_terceirizadas/form/${this.idInventario}`,
      icon: "handshake",
    },
    {
      key: "PRODUTOS_FLORESTAIS_MADEIREIROS",
      label: "Produtos Florestais Madeireiros",
      getRoute: () =>
        `/produtos-florestais-madereiros/form/${this.idInventario}`,
      icon: "park",
    },
    {
      key: "MUDANCA_CARBONO_SOLO",
      label: "Mudança de Carbono no Solo",
      getRoute: () => `/mudanca-carbono-solo/form/${this.idInventario}`,
      icon: "layers",
    },
    {
      key: "MUDANCA_USO_SOLO",
      label: "Mudança de Uso de Solo",
      getRoute: () => `/mudanca-uso-solo/form/${this.idInventario}`,
      icon: "terrain",
    },
    {
      key: "INVENTARIO_ILPF",
      label: "ILPF",
      getRoute: () => `/inventario-ilpf/form/${this.idInventario}`,
      icon: "eco",
    },
    {
      key: "INVENTARIO_CULTIVO_ARROZ",
      label: "Cultivo de Arroz Irrigado",
      getRoute: () => `/inventario-cultivo-arroz/form/${this.idInventario}`,
      icon: "water_drop",
    },
    {
      key: "INVENTARIO_AGRICULTURA_PERENE",
      label: "Agricultura Perene",
      getRoute: () =>
        `/inventario-agricultura-perene/form/${this.idInventario}`,
      icon: "nature",
    },
    {
      key: "RESIDUO_SOLIDO_AGROPECUARIO",
      label: "Resíduo Sólido Agropecuário",
      getRoute: () => `/residuo_solido_agropecuario/form/${this.idInventario}`,
      icon: "delete_outline",
    },
    {
      key: "INVENTARIO_DEFENSIVO_AGRICOLA",
      label: "Defensivos Agrícolas",
      getRoute: () => `/defensivos-agricolas/form/${this.idInventario}`,
      icon: "biotech",
    },
    {
      key: "INVENTARIO",
      label: "Mapa",
      getRoute: () => `/mapa/${this.latitude}/${this.longitude}`,
      icon: "map",
    },
  ];

  ngOnInit(): void {
    this.inventarioContext.context$.subscribe(context => {
      this.idInventario = context.idInventario ?? this.idInventario;
      this.latitude = context.latitude ?? this.latitude;
      this.longitude = context.longitude ?? this.longitude;

      this.isNovo = this.idInventario === "novo";

      if (this.idInventario && !this.isNovo) {
        this.carregarStatusFormularios();
      }
    });
  }

  carregarStatusFormularios(): void {
    if (!this.idInventario || this.isNovo) return;

    this.inventarioService.getStatusFormulario(this.idInventario).subscribe({
      next: (data) => {
        this.statusFormularios = { ...data.formulario };
      },
      error: (err) => {
        console.error("Erro ao buscar status:", err);
      }
    });
  }

  navigateTo(routeGetter: () => string | null) {
    if (!this.idInventario) {
      console.warn("🚫 idInventario não disponível no contexto.");
      return;
    }

    const route = routeGetter();

    if (!route || route.includes("undefined") || route.includes("null")) {
      console.warn("🚫 Rota inválida:", route);
      return;
    }

    this.router.navigate([route]);
    this.closeMenu.emit();
  }

  gerarRelatorio(): void {
    const url = `${environment.api}/inventario/relatorio/email/${this.idInventario}`;

    this.http.post<any>(url, {}).subscribe({
      next: (response) => {

        this.dialog.open(RelatorioEmailDialogComponent, {
          width: '420px',
          disableClose: true,
          panelClass: 'dialog-success',
          data: {
            type: 'success',
            email: response.email,
            emails: response.emails ?? (response.email ? [response.email] : [])
          }
        });

      },
      error: (response) => {
        this.dialog.open(RelatorioEmailDialogComponent, {
          width: '420px',
          disableClose: true,
          panelClass: 'dialog-error',
          data: {
            type: 'error',
            message: response.message
          }
        });
      }
    });
  }
}